import { render } from "./Faq.vue?vue&type=template&id=4827ed22&scoped=true"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"

import "./Faq.vue?vue&type=style&index=0&id=4827ed22&scoped=true&lang=css"

import exportComponent from "/home/runner/work/yohom_cp/yohom_cp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4827ed22"]])

export default __exports__